/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  AddressDTO,
  AddressDTOOptional,
  AddressDTOMetaI,
  AddressDTOTrackedI,
} from "./address-dto";
import { AddressDTOTracked, AddressDTOMeta } from "./address-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CardDTO,
  CardDTOOptional,
  CardDTOMetaI,
  CardDTOTrackedI,
} from "./card-dto";
import { CardDTOTracked, CardDTOMeta } from "./card-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  DamageWaiverDTO,
  DamageWaiverDTOOptional,
  DamageWaiverDTOMetaI,
  DamageWaiverDTOTrackedI,
} from "./damage-waiver-dto";
import {
  DamageWaiverDTOTracked,
  DamageWaiverDTOMeta,
} from "./damage-waiver-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  MembershipDTO,
  MembershipDTOOptional,
  MembershipDTOMetaI,
  MembershipDTOTrackedI,
} from "./membership-dto";
import { MembershipDTOTracked, MembershipDTOMeta } from "./membership-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPublicChildAndParentDTO,
  PersonPublicChildAndParentDTOOptional,
  PersonPublicChildAndParentDTOMetaI,
  PersonPublicChildAndParentDTOTrackedI,
} from "./person-public-child-and-parent-dto";
import {
  PersonPublicChildAndParentDTOTracked,
  PersonPublicChildAndParentDTOMeta,
} from "./person-public-child-and-parent-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPublicChildDTO,
  PersonPublicChildDTOOptional,
  PersonPublicChildDTOMetaI,
  PersonPublicChildDTOTrackedI,
} from "./person-public-child-dto";
import {
  PersonPublicChildDTOTracked,
  PersonPublicChildDTOMeta,
} from "./person-public-child-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonPublicRelatedDTO,
  PersonPublicRelatedDTOOptional,
  PersonPublicRelatedDTOMetaI,
  PersonPublicRelatedDTOTrackedI,
} from "./person-public-related-dto";
import {
  PersonPublicRelatedDTOTracked,
  PersonPublicRelatedDTOMeta,
} from "./person-public-related-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonReferralDTO,
  PersonReferralDTOOptional,
  PersonReferralDTOMetaI,
  PersonReferralDTOTrackedI,
} from "./person-referral-dto";
import {
  PersonReferralDTOTracked,
  PersonReferralDTOMeta,
} from "./person-referral-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PersonTypeEnum,
  PersonTypeEnumOptional,
  PersonTypeEnumMetaI,
  PersonTypeEnumTrackedI,
} from "./person-type-enum";
import { PersonTypeEnumTracked, PersonTypeEnumMeta } from "./person-type-enum";
// May contain unused imports in some cases
// @ts-ignore
import type {
  PhoneDTO,
  PhoneDTOOptional,
  PhoneDTOMetaI,
  PhoneDTOTrackedI,
} from "./phone-dto";
import { PhoneDTOTracked, PhoneDTOMeta } from "./phone-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  SwimProof,
  SwimProofOptional,
  SwimProofMetaI,
  SwimProofTrackedI,
} from "./swim-proof";
import { SwimProofTracked, SwimProofMeta } from "./swim-proof";

/**
 *
 * @export
 * @interface PersonPublicParentDTO
 */
export interface PersonPublicParentDTOOptional extends PersonPublicChildAndParentDTOOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPublicParentDTO
   */
  assignId?: number;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  allowSignouts?: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonPublicParentDTO
   */
  personType?: PersonTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  allergies?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  medications?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  specialNeeds?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  occupation?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  ethnicity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  language?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  matchingGifts?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  student?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  school?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  military?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  reducedLunch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  previousMember?: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonPublicParentDTO
   */
  swimProof?: SwimProof;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  dob?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  dobVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  temp?: string;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonPublicParentDTO
   */
  referrals?: PersonReferralDTOOptional[];
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonPublicParentDTO
   */
  phones?: PhoneDTOOptional[];
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonPublicParentDTO
   */
  addresses?: AddressDTOOptional[];
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  isLocked?: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentDamageWaivers?: DamageWaiverDTOOptional[];
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentMemberships?: MembershipDTOOptional[];
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentCards?: CardDTOOptional[];
  /**
   *
   * @type {Array<PersonPublicRelatedDTO>}
   * @memberof PersonPublicParentDTO
   */
  emergencyContacts?: PersonPublicRelatedDTOOptional[];
  /**
   *
   * @type {Array<PersonPublicChildDTO>}
   * @memberof PersonPublicParentDTO
   */
  children?: PersonPublicChildDTOOptional[];
}

export interface PersonPublicParentDTO
  extends PersonPublicParentDTOOptional, PersonPublicChildAndParentDTO {
  /**
   *
   * @type {number}
   * @memberof PersonPublicParentDTO
   */
  assignId: number;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  prefix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  first?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  middle?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  last?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  suffix?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  preferred?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  organization?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  email?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  allowSignouts?: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonPublicParentDTO
   */
  personType?: PersonTypeEnum;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  allergies?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  medications?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  specialNeeds?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  gender?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  occupation?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  citizenship?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  ethnicity?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  language?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  matchingGifts?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  student?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  school?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  military?: string;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  reducedLunch?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  previousMember?: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonPublicParentDTO
   */
  swimProof?: SwimProof;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  dob?: Date;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  dobVerified?: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  stripeCustomerId?: string;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  temp: string;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonPublicParentDTO
   */
  referrals?: PersonReferralDTO[];
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonPublicParentDTO
   */
  phones?: PhoneDTO[];
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonPublicParentDTO
   */
  addresses?: AddressDTO[];
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  isLocked?: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentDamageWaivers?: DamageWaiverDTO[];
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentMemberships?: MembershipDTO[];
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentCards?: CardDTO[];
  /**
   *
   * @type {Array<PersonPublicRelatedDTO>}
   * @memberof PersonPublicParentDTO
   */
  emergencyContacts?: PersonPublicRelatedDTO[];
  /**
   *
   * @type {Array<PersonPublicChildDTO>}
   * @memberof PersonPublicParentDTO
   */
  children?: PersonPublicChildDTO[];
}

export interface PersonPublicParentDTOTrackedI extends PersonPublicChildAndParentDTOOptional {
  /**
   *
   * @type {number}
   * @memberof PersonPublicParentDTO
   */
  assignId?: number;
  assignIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  prefix?: string;
  prefixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  first?: string;
  firstIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  middle?: string;
  middleIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  last?: string;
  lastIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  suffix?: string;
  suffixIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  preferred?: string;
  preferredIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  organization?: string;
  organizationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  email?: string;
  emailIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  allowSignouts?: boolean;
  allowSignoutsIsSet: boolean;
  /**
   *
   * @type {PersonTypeEnum}
   * @memberof PersonPublicParentDTO
   */
  personType?: PersonTypeEnum;
  personTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  allergies?: string;
  allergiesIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  medications?: string;
  medicationsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  specialNeeds?: string;
  specialNeedsIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  gender?: string;
  genderIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  occupation?: string;
  occupationIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  citizenship?: string;
  citizenshipIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  ethnicity?: string;
  ethnicityIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  language?: string;
  languageIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  matchingGifts?: string;
  matchingGiftsIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  student?: boolean;
  studentIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  school?: string;
  schoolIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  military?: string;
  militaryIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  reducedLunch?: boolean;
  reducedLunchIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  previousMember?: boolean;
  previousMemberIsSet: boolean;
  /**
   *
   * @type {SwimProof}
   * @memberof PersonPublicParentDTO
   */
  swimProof?: SwimProof;
  swimProofIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  dob?: Date;
  dobIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  dobVerified?: boolean;
  dobVerifiedIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  stripeCustomerId?: string;
  stripeCustomerIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonPublicParentDTO
   */
  temp?: string;
  tempIsSet: boolean;
  /**
   *
   * @type {Array<PersonReferralDTO>}
   * @memberof PersonPublicParentDTO
   */
  referrals?: PersonReferralDTOTrackedI[];
  referralsIsSet: boolean;
  /**
   *
   * @type {Array<PhoneDTO>}
   * @memberof PersonPublicParentDTO
   */
  phones?: PhoneDTOTrackedI[];
  phonesIsSet: boolean;
  /**
   *
   * @type {Array<AddressDTO>}
   * @memberof PersonPublicParentDTO
   */
  addresses?: AddressDTOTrackedI[];
  addressesIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof PersonPublicParentDTO
   */
  isLocked?: boolean;
  isLockedIsSet: boolean;
  /**
   *
   * @type {Array<DamageWaiverDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentDamageWaivers?: DamageWaiverDTOTrackedI[];
  currentDamageWaiversIsSet: boolean;
  /**
   *
   * @type {Array<MembershipDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentMemberships?: MembershipDTOTrackedI[];
  currentMembershipsIsSet: boolean;
  /**
   *
   * @type {Array<CardDTO>}
   * @memberof PersonPublicParentDTO
   */
  currentCards?: CardDTOTrackedI[];
  currentCardsIsSet: boolean;
  /**
   *
   * @type {Array<PersonPublicRelatedDTO>}
   * @memberof PersonPublicParentDTO
   */
  emergencyContacts?: PersonPublicRelatedDTOTrackedI[];
  emergencyContactsIsSet: boolean;
  /**
   *
   * @type {Array<PersonPublicChildDTO>}
   * @memberof PersonPublicParentDTO
   */
  children?: PersonPublicChildDTOTrackedI[];
  childrenIsSet: boolean;
}

transformDatesMap.set(
  "PersonPublicParentDTO",
  function (model: PersonPublicParentDTO) {
    if (typeof model.dob == "string") model.dob = new Date(model.dob);
    const transformDatesreferrals = transformDatesMap.get("PersonReferralDTO");
    if (transformDatesreferrals) {
      model.referrals?.forEach((sub) => {
        transformDatesreferrals(sub);
      });
    }
    const transformDatesphones = transformDatesMap.get("PhoneDTO");
    if (transformDatesphones) {
      model.phones?.forEach((sub) => {
        transformDatesphones(sub);
      });
    }
    const transformDatesaddresses = transformDatesMap.get("AddressDTO");
    if (transformDatesaddresses) {
      model.addresses?.forEach((sub) => {
        transformDatesaddresses(sub);
      });
    }
    const transformDatescurrentDamageWaivers =
      transformDatesMap.get("DamageWaiverDTO");
    if (transformDatescurrentDamageWaivers) {
      model.currentDamageWaivers?.forEach((sub) => {
        transformDatescurrentDamageWaivers(sub);
      });
    }
    const transformDatescurrentMemberships =
      transformDatesMap.get("MembershipDTO");
    if (transformDatescurrentMemberships) {
      model.currentMemberships?.forEach((sub) => {
        transformDatescurrentMemberships(sub);
      });
    }
    const transformDatescurrentCards = transformDatesMap.get("CardDTO");
    if (transformDatescurrentCards) {
      model.currentCards?.forEach((sub) => {
        transformDatescurrentCards(sub);
      });
    }
    const transformDatesemergencyContacts = transformDatesMap.get(
      "PersonPublicRelatedDTO",
    );
    if (transformDatesemergencyContacts) {
      model.emergencyContacts?.forEach((sub) => {
        transformDatesemergencyContacts(sub);
      });
    }
    const transformDateschildren = transformDatesMap.get(
      "PersonPublicChildDTO",
    );
    if (transformDateschildren) {
      model.children?.forEach((sub) => {
        transformDateschildren(sub);
      });
    }
  },
);

export type PersonPublicParentDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  assignId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  prefix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  first: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  middle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  last: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  suffix: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  preferred: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  organization: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  email: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  allowSignouts: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  personType: PropertyMeta<PersonTypeEnumMetaI>;
  //isDate: false
  //isDatetime: false
  allergies: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  medications: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  specialNeeds: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  gender: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  occupation: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  citizenship: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  ethnicity: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  language: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  matchingGifts: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  student: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  school: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  military: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reducedLunch: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  previousMember: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  swimProof: PropertyMeta<SwimProofMetaI>;
  //isDate: false
  //isDatetime: true
  dob: PropertyMeta<MetaTypeBase<Date>>;
  //isDate: false
  //isDatetime: false
  dobVerified: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  stripeCustomerId: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  temp: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  referrals: PropertyMeta<PersonReferralDTOMetaI>;
  //isDate: false
  //isDatetime: false
  phones: PropertyMeta<PhoneDTOMetaI>;
  //isDate: false
  //isDatetime: false
  addresses: PropertyMeta<AddressDTOMetaI>;
  //isDate: false
  //isDatetime: false
  isLocked: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  currentDamageWaivers: PropertyMeta<DamageWaiverDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentMemberships: PropertyMeta<MembershipDTOMetaI>;
  //isDate: false
  //isDatetime: false
  currentCards: PropertyMeta<CardDTOMetaI>;
  //isDate: false
  //isDatetime: false
  emergencyContacts: PropertyMeta<PersonPublicRelatedDTOMetaI>;
  //isDate: false
  //isDatetime: false
  children: PropertyMeta<PersonPublicChildDTOMetaI>;
}>;

export var PersonPublicParentDTOMeta: PersonPublicParentDTOMetaI =
  {} as PersonPublicParentDTOMetaI;
PersonPublicParentDTOMeta = typeMeta("PersonPublicParentDTO", {
  assignId: propertyMeta("assignId", false, true, true, MetaTypesBase.number),
  prefix: propertyMeta("prefix", false, false, false, MetaTypesBase.string),
  first: propertyMeta("first", false, false, false, MetaTypesBase.string),
  middle: propertyMeta("middle", false, false, false, MetaTypesBase.string),
  last: propertyMeta("last", false, false, false, MetaTypesBase.string),
  suffix: propertyMeta("suffix", false, false, false, MetaTypesBase.string),
  preferred: propertyMeta(
    "preferred",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  organization: propertyMeta(
    "organization",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  email: propertyMeta("email", false, false, false, MetaTypesBase.string),
  allowSignouts: propertyMeta(
    "allowSignouts",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  personType: propertyMeta(
    "personType",
    false,
    false,
    false,
    PersonTypeEnumMeta,
  ),
  allergies: propertyMeta(
    "allergies",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  medications: propertyMeta(
    "medications",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  specialNeeds: propertyMeta(
    "specialNeeds",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  gender: propertyMeta("gender", false, false, false, MetaTypesBase.string),
  occupation: propertyMeta(
    "occupation",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  citizenship: propertyMeta(
    "citizenship",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  ethnicity: propertyMeta(
    "ethnicity",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  language: propertyMeta("language", false, false, false, MetaTypesBase.string),
  matchingGifts: propertyMeta(
    "matchingGifts",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  student: propertyMeta("student", false, false, false, MetaTypesBase.boolean),
  school: propertyMeta("school", false, false, false, MetaTypesBase.string),
  military: propertyMeta("military", false, false, false, MetaTypesBase.string),
  reducedLunch: propertyMeta(
    "reducedLunch",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  previousMember: propertyMeta(
    "previousMember",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  swimProof: propertyMeta("swimProof", false, false, false, SwimProofMeta),
  dob: propertyMeta("dob", false, false, false, MetaTypesBase.Date),
  dobVerified: propertyMeta(
    "dobVerified",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  stripeCustomerId: propertyMeta(
    "stripeCustomerId",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  temp: propertyMeta("temp", false, true, false, MetaTypesBase.string),
  referrals: propertyMeta(
    "referrals",
    true,
    false,
    false,
    PersonReferralDTOMeta,
  ),
  phones: propertyMeta("phones", true, false, false, PhoneDTOMeta),
  addresses: propertyMeta("addresses", true, false, false, AddressDTOMeta),
  isLocked: propertyMeta(
    "isLocked",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  currentDamageWaivers: propertyMeta(
    "currentDamageWaivers",
    true,
    false,
    false,
    DamageWaiverDTOMeta,
  ),
  currentMemberships: propertyMeta(
    "currentMemberships",
    true,
    false,
    false,
    MembershipDTOMeta,
  ),
  currentCards: propertyMeta("currentCards", true, false, false, CardDTOMeta),
  emergencyContacts: propertyMeta(
    "emergencyContacts",
    true,
    false,
    false,
    PersonPublicRelatedDTOMeta,
  ),
  children: propertyMeta(
    "children",
    true,
    false,
    false,
    PersonPublicChildDTOMeta,
  ),
});

const metaI = PersonPublicParentDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([
    PersonPublicChildAndParentDTOMeta,
  ]);
  metaI.assignId.inheritedFrom = PersonPublicChildAndParentDTOMeta.assignId;
  metaI.prefix.inheritedFrom = PersonPublicChildAndParentDTOMeta.prefix;
  metaI.first.inheritedFrom = PersonPublicChildAndParentDTOMeta.first;
  metaI.middle.inheritedFrom = PersonPublicChildAndParentDTOMeta.middle;
  metaI.last.inheritedFrom = PersonPublicChildAndParentDTOMeta.last;
  metaI.suffix.inheritedFrom = PersonPublicChildAndParentDTOMeta.suffix;
  metaI.preferred.inheritedFrom = PersonPublicChildAndParentDTOMeta.preferred;
  metaI.organization.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.organization;
  metaI.email.inheritedFrom = PersonPublicChildAndParentDTOMeta.email;
  metaI.allowSignouts.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.allowSignouts;
  metaI.personType.inheritedFrom = PersonPublicChildAndParentDTOMeta.personType;
  metaI.allergies.inheritedFrom = PersonPublicChildAndParentDTOMeta.allergies;
  metaI.medications.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.medications;
  metaI.specialNeeds.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.specialNeeds;
  metaI.gender.inheritedFrom = PersonPublicChildAndParentDTOMeta.gender;
  metaI.occupation.inheritedFrom = PersonPublicChildAndParentDTOMeta.occupation;
  metaI.citizenship.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.citizenship;
  metaI.ethnicity.inheritedFrom = PersonPublicChildAndParentDTOMeta.ethnicity;
  metaI.language.inheritedFrom = PersonPublicChildAndParentDTOMeta.language;
  metaI.matchingGifts.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.matchingGifts;
  metaI.student.inheritedFrom = PersonPublicChildAndParentDTOMeta.student;
  metaI.school.inheritedFrom = PersonPublicChildAndParentDTOMeta.school;
  metaI.military.inheritedFrom = PersonPublicChildAndParentDTOMeta.military;
  metaI.reducedLunch.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.reducedLunch;
  metaI.previousMember.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.previousMember;
  metaI.swimProof.inheritedFrom = PersonPublicChildAndParentDTOMeta.swimProof;
  metaI.dob.inheritedFrom = PersonPublicChildAndParentDTOMeta.dob;
  metaI.dobVerified.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.dobVerified;
  metaI.stripeCustomerId.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.stripeCustomerId;
  metaI.temp.inheritedFrom = PersonPublicChildAndParentDTOMeta.temp;
  metaI.referrals.inheritedFrom = PersonPublicChildAndParentDTOMeta.referrals;
  metaI.phones.inheritedFrom = PersonPublicChildAndParentDTOMeta.phones;
  metaI.addresses.inheritedFrom = PersonPublicChildAndParentDTOMeta.addresses;
  metaI.isLocked.inheritedFrom = PersonPublicChildAndParentDTOMeta.isLocked;
  metaI.currentDamageWaivers.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.currentDamageWaivers;
  metaI.currentMemberships.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.currentMemberships;
  metaI.currentCards.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.currentCards;
  metaI.emergencyContacts.inheritedFrom =
    PersonPublicChildAndParentDTOMeta.emergencyContacts;
});

export class PersonPublicParentDTOTracked
  extends PersonPublicChildAndParentDTOTracked
  implements PersonPublicParentDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  assignId__I?: number = undefined;

  get assignIdIsSet() {
    return this.assignId !== undefined;
  }
  set assignIdIsSet(v: boolean) {}
  set assignId(v: undefined | number) {
    if (v !== undefined) {
      this.assignId__I = v;
      this.assignIdIsSet = true;
    } else {
      this.assignId__I = v || undefined;
      this.assignIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get assignId() {
    return this.assignId__I;
  }
  prefix__I?: string = undefined;
  prefixIsSet: boolean = false;
  set prefix(v: undefined | string) {
    if (v !== undefined) {
      this.prefix__I = v;
      this.prefixIsSet = true;
    } else {
      this.prefix__I = v || undefined;
      this.prefixIsSet = false;
    }
    this.changeTracker = true;
  }
  get prefix() {
    return this.prefix__I;
  }
  first__I?: string = undefined;
  firstIsSet: boolean = false;
  set first(v: undefined | string) {
    if (v !== undefined) {
      this.first__I = v;
      this.firstIsSet = true;
    } else {
      this.first__I = v || undefined;
      this.firstIsSet = false;
    }
    this.changeTracker = true;
  }
  get first() {
    return this.first__I;
  }
  middle__I?: string = undefined;
  middleIsSet: boolean = false;
  set middle(v: undefined | string) {
    if (v !== undefined) {
      this.middle__I = v;
      this.middleIsSet = true;
    } else {
      this.middle__I = v || undefined;
      this.middleIsSet = false;
    }
    this.changeTracker = true;
  }
  get middle() {
    return this.middle__I;
  }
  last__I?: string = undefined;
  lastIsSet: boolean = false;
  set last(v: undefined | string) {
    if (v !== undefined) {
      this.last__I = v;
      this.lastIsSet = true;
    } else {
      this.last__I = v || undefined;
      this.lastIsSet = false;
    }
    this.changeTracker = true;
  }
  get last() {
    return this.last__I;
  }
  suffix__I?: string = undefined;
  suffixIsSet: boolean = false;
  set suffix(v: undefined | string) {
    if (v !== undefined) {
      this.suffix__I = v;
      this.suffixIsSet = true;
    } else {
      this.suffix__I = v || undefined;
      this.suffixIsSet = false;
    }
    this.changeTracker = true;
  }
  get suffix() {
    return this.suffix__I;
  }
  preferred__I?: string = undefined;
  preferredIsSet: boolean = false;
  set preferred(v: undefined | string) {
    if (v !== undefined) {
      this.preferred__I = v;
      this.preferredIsSet = true;
    } else {
      this.preferred__I = v || undefined;
      this.preferredIsSet = false;
    }
    this.changeTracker = true;
  }
  get preferred() {
    return this.preferred__I;
  }
  organization__I?: string = undefined;
  organizationIsSet: boolean = false;
  set organization(v: undefined | string) {
    if (v !== undefined) {
      this.organization__I = v;
      this.organizationIsSet = true;
    } else {
      this.organization__I = v || undefined;
      this.organizationIsSet = false;
    }
    this.changeTracker = true;
  }
  get organization() {
    return this.organization__I;
  }
  email__I?: string = undefined;
  emailIsSet: boolean = false;
  set email(v: undefined | string) {
    if (v !== undefined) {
      this.email__I = v;
      this.emailIsSet = true;
    } else {
      this.email__I = v || undefined;
      this.emailIsSet = false;
    }
    this.changeTracker = true;
  }
  get email() {
    return this.email__I;
  }
  allowSignouts__I?: boolean = undefined;
  allowSignoutsIsSet: boolean = false;
  set allowSignouts(v: undefined | boolean) {
    if (v !== undefined) {
      this.allowSignouts__I = v;
      this.allowSignoutsIsSet = true;
    } else {
      this.allowSignouts__I = v || undefined;
      this.allowSignoutsIsSet = false;
    }
    this.changeTracker = true;
  }
  get allowSignouts() {
    return this.allowSignouts__I;
  }
  personType__I?: PersonTypeEnum = undefined;
  personTypeIsSet: boolean = false;
  set personType(v: undefined | PersonTypeEnum) {
    if (v !== undefined) {
      this.personType__I = v;
      this.personTypeIsSet = true;
    } else {
      this.personType__I = v || undefined;
      this.personTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get personType() {
    return this.personType__I;
  }
  allergies__I?: string = undefined;
  allergiesIsSet: boolean = false;
  set allergies(v: undefined | string) {
    if (v !== undefined) {
      this.allergies__I = v;
      this.allergiesIsSet = true;
    } else {
      this.allergies__I = v || undefined;
      this.allergiesIsSet = false;
    }
    this.changeTracker = true;
  }
  get allergies() {
    return this.allergies__I;
  }
  medications__I?: string = undefined;
  medicationsIsSet: boolean = false;
  set medications(v: undefined | string) {
    if (v !== undefined) {
      this.medications__I = v;
      this.medicationsIsSet = true;
    } else {
      this.medications__I = v || undefined;
      this.medicationsIsSet = false;
    }
    this.changeTracker = true;
  }
  get medications() {
    return this.medications__I;
  }
  specialNeeds__I?: string = undefined;
  specialNeedsIsSet: boolean = false;
  set specialNeeds(v: undefined | string) {
    if (v !== undefined) {
      this.specialNeeds__I = v;
      this.specialNeedsIsSet = true;
    } else {
      this.specialNeeds__I = v || undefined;
      this.specialNeedsIsSet = false;
    }
    this.changeTracker = true;
  }
  get specialNeeds() {
    return this.specialNeeds__I;
  }
  gender__I?: string = undefined;
  genderIsSet: boolean = false;
  set gender(v: undefined | string) {
    if (v !== undefined) {
      this.gender__I = v;
      this.genderIsSet = true;
    } else {
      this.gender__I = v || undefined;
      this.genderIsSet = false;
    }
    this.changeTracker = true;
  }
  get gender() {
    return this.gender__I;
  }
  occupation__I?: string = undefined;
  occupationIsSet: boolean = false;
  set occupation(v: undefined | string) {
    if (v !== undefined) {
      this.occupation__I = v;
      this.occupationIsSet = true;
    } else {
      this.occupation__I = v || undefined;
      this.occupationIsSet = false;
    }
    this.changeTracker = true;
  }
  get occupation() {
    return this.occupation__I;
  }
  citizenship__I?: string = undefined;
  citizenshipIsSet: boolean = false;
  set citizenship(v: undefined | string) {
    if (v !== undefined) {
      this.citizenship__I = v;
      this.citizenshipIsSet = true;
    } else {
      this.citizenship__I = v || undefined;
      this.citizenshipIsSet = false;
    }
    this.changeTracker = true;
  }
  get citizenship() {
    return this.citizenship__I;
  }
  ethnicity__I?: string = undefined;
  ethnicityIsSet: boolean = false;
  set ethnicity(v: undefined | string) {
    if (v !== undefined) {
      this.ethnicity__I = v;
      this.ethnicityIsSet = true;
    } else {
      this.ethnicity__I = v || undefined;
      this.ethnicityIsSet = false;
    }
    this.changeTracker = true;
  }
  get ethnicity() {
    return this.ethnicity__I;
  }
  language__I?: string = undefined;
  languageIsSet: boolean = false;
  set language(v: undefined | string) {
    if (v !== undefined) {
      this.language__I = v;
      this.languageIsSet = true;
    } else {
      this.language__I = v || undefined;
      this.languageIsSet = false;
    }
    this.changeTracker = true;
  }
  get language() {
    return this.language__I;
  }
  matchingGifts__I?: string = undefined;
  matchingGiftsIsSet: boolean = false;
  set matchingGifts(v: undefined | string) {
    if (v !== undefined) {
      this.matchingGifts__I = v;
      this.matchingGiftsIsSet = true;
    } else {
      this.matchingGifts__I = v || undefined;
      this.matchingGiftsIsSet = false;
    }
    this.changeTracker = true;
  }
  get matchingGifts() {
    return this.matchingGifts__I;
  }
  student__I?: boolean = undefined;
  studentIsSet: boolean = false;
  set student(v: undefined | boolean) {
    if (v !== undefined) {
      this.student__I = v;
      this.studentIsSet = true;
    } else {
      this.student__I = v || undefined;
      this.studentIsSet = false;
    }
    this.changeTracker = true;
  }
  get student() {
    return this.student__I;
  }
  school__I?: string = undefined;
  schoolIsSet: boolean = false;
  set school(v: undefined | string) {
    if (v !== undefined) {
      this.school__I = v;
      this.schoolIsSet = true;
    } else {
      this.school__I = v || undefined;
      this.schoolIsSet = false;
    }
    this.changeTracker = true;
  }
  get school() {
    return this.school__I;
  }
  military__I?: string = undefined;
  militaryIsSet: boolean = false;
  set military(v: undefined | string) {
    if (v !== undefined) {
      this.military__I = v;
      this.militaryIsSet = true;
    } else {
      this.military__I = v || undefined;
      this.militaryIsSet = false;
    }
    this.changeTracker = true;
  }
  get military() {
    return this.military__I;
  }
  reducedLunch__I?: boolean = undefined;
  reducedLunchIsSet: boolean = false;
  set reducedLunch(v: undefined | boolean) {
    if (v !== undefined) {
      this.reducedLunch__I = v;
      this.reducedLunchIsSet = true;
    } else {
      this.reducedLunch__I = v || undefined;
      this.reducedLunchIsSet = false;
    }
    this.changeTracker = true;
  }
  get reducedLunch() {
    return this.reducedLunch__I;
  }
  previousMember__I?: boolean = undefined;
  previousMemberIsSet: boolean = false;
  set previousMember(v: undefined | boolean) {
    if (v !== undefined) {
      this.previousMember__I = v;
      this.previousMemberIsSet = true;
    } else {
      this.previousMember__I = v || undefined;
      this.previousMemberIsSet = false;
    }
    this.changeTracker = true;
  }
  get previousMember() {
    return this.previousMember__I;
  }
  swimProof__I?: SwimProof = undefined;
  swimProofIsSet: boolean = false;
  set swimProof(v: undefined | SwimProof) {
    if (v !== undefined) {
      this.swimProof__I = v;
      this.swimProofIsSet = true;
    } else {
      this.swimProof__I = v || undefined;
      this.swimProofIsSet = false;
    }
    this.changeTracker = true;
  }
  get swimProof() {
    return this.swimProof__I;
  }
  dob__I?: Date = undefined;
  dobIsSet: boolean = false;
  set dob(v: undefined | Date) {
    if (v !== undefined) {
      this.dob__I = v;
      this.dobIsSet = true;
    } else {
      this.dob__I = v || undefined;
      this.dobIsSet = false;
    }
    this.changeTracker = true;
  }
  get dob() {
    return this.dob__I;
  }
  dobVerified__I?: boolean = undefined;
  dobVerifiedIsSet: boolean = false;
  set dobVerified(v: undefined | boolean) {
    if (v !== undefined) {
      this.dobVerified__I = v;
      this.dobVerifiedIsSet = true;
    } else {
      this.dobVerified__I = v || undefined;
      this.dobVerifiedIsSet = false;
    }
    this.changeTracker = true;
  }
  get dobVerified() {
    return this.dobVerified__I;
  }
  stripeCustomerId__I?: string = undefined;
  stripeCustomerIdIsSet: boolean = false;
  set stripeCustomerId(v: undefined | string) {
    if (v !== undefined) {
      this.stripeCustomerId__I = v;
      this.stripeCustomerIdIsSet = true;
    } else {
      this.stripeCustomerId__I = v || undefined;
      this.stripeCustomerIdIsSet = false;
    }
    this.changeTracker = true;
  }
  get stripeCustomerId() {
    return this.stripeCustomerId__I;
  }
  temp__I?: string = undefined;
  tempIsSet: boolean = false;
  set temp(v: undefined | string) {
    if (v !== undefined) {
      this.temp__I = v;
      this.tempIsSet = true;
    } else {
      this.temp__I = v || undefined;
      this.tempIsSet = true;
    }
    this.changeTracker = true;
  }
  get temp() {
    return this.temp__I;
  }
  referrals__I?: PersonReferralDTOTracked[] = undefined;
  referralsIsSet: boolean = false;
  set referrals(v: undefined | PersonReferralDTOTracked[]) {
    if (v !== undefined) {
      this.referrals__I = v;
      this.referralsIsSet = true;
    } else {
      this.referrals__I = v || undefined;
      this.referralsIsSet = false;
    }
    this.changeTracker = true;
  }
  get referrals() {
    return this.referrals__I;
  }
  phones__I?: PhoneDTOTracked[] = undefined;
  phonesIsSet: boolean = false;
  set phones(v: undefined | PhoneDTOTracked[]) {
    if (v !== undefined) {
      this.phones__I = v;
      this.phonesIsSet = true;
    } else {
      this.phones__I = v || undefined;
      this.phonesIsSet = false;
    }
    this.changeTracker = true;
  }
  get phones() {
    return this.phones__I;
  }
  addresses__I?: AddressDTOTracked[] = undefined;
  addressesIsSet: boolean = false;
  set addresses(v: undefined | AddressDTOTracked[]) {
    if (v !== undefined) {
      this.addresses__I = v;
      this.addressesIsSet = true;
    } else {
      this.addresses__I = v || undefined;
      this.addressesIsSet = false;
    }
    this.changeTracker = true;
  }
  get addresses() {
    return this.addresses__I;
  }
  isLocked__I?: boolean = undefined;
  isLockedIsSet: boolean = false;
  set isLocked(v: undefined | boolean) {
    if (v !== undefined) {
      this.isLocked__I = v;
      this.isLockedIsSet = true;
    } else {
      this.isLocked__I = v || undefined;
      this.isLockedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isLocked() {
    return this.isLocked__I;
  }
  currentDamageWaivers__I?: DamageWaiverDTOTracked[] = undefined;
  currentDamageWaiversIsSet: boolean = false;
  set currentDamageWaivers(v: undefined | DamageWaiverDTOTracked[]) {
    if (v !== undefined) {
      this.currentDamageWaivers__I = v;
      this.currentDamageWaiversIsSet = true;
    } else {
      this.currentDamageWaivers__I = v || undefined;
      this.currentDamageWaiversIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentDamageWaivers() {
    return this.currentDamageWaivers__I;
  }
  currentMemberships__I?: MembershipDTOTracked[] = undefined;
  currentMembershipsIsSet: boolean = false;
  set currentMemberships(v: undefined | MembershipDTOTracked[]) {
    if (v !== undefined) {
      this.currentMemberships__I = v;
      this.currentMembershipsIsSet = true;
    } else {
      this.currentMemberships__I = v || undefined;
      this.currentMembershipsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentMemberships() {
    return this.currentMemberships__I;
  }
  currentCards__I?: CardDTOTracked[] = undefined;
  currentCardsIsSet: boolean = false;
  set currentCards(v: undefined | CardDTOTracked[]) {
    if (v !== undefined) {
      this.currentCards__I = v;
      this.currentCardsIsSet = true;
    } else {
      this.currentCards__I = v || undefined;
      this.currentCardsIsSet = false;
    }
    this.changeTracker = true;
  }
  get currentCards() {
    return this.currentCards__I;
  }
  emergencyContacts__I?: PersonPublicRelatedDTOTracked[] = undefined;
  emergencyContactsIsSet: boolean = false;
  set emergencyContacts(v: undefined | PersonPublicRelatedDTOTracked[]) {
    if (v !== undefined) {
      this.emergencyContacts__I = v;
      this.emergencyContactsIsSet = true;
    } else {
      this.emergencyContacts__I = v || undefined;
      this.emergencyContactsIsSet = false;
    }
    this.changeTracker = true;
  }
  get emergencyContacts() {
    return this.emergencyContacts__I;
  }
  children__I?: PersonPublicChildDTOTracked[] = undefined;
  childrenIsSet: boolean = false;
  set children(v: undefined | PersonPublicChildDTOTracked[]) {
    if (v !== undefined) {
      this.children__I = v;
      this.childrenIsSet = true;
    } else {
      this.children__I = v || undefined;
      this.childrenIsSet = false;
    }
    this.changeTracker = true;
  }
  get children() {
    return this.children__I;
  }
  constructor(config?: PersonPublicParentDTOOptional, options?: AssignOptions) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.assignIdIsSet == true && other?.assignIdIsSet == true)
      return this.assignId == other.assignId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.assignId) {
      this.assignIdIsSet = true;
    }

    this.referrals?.forEach((a) => a.setIds());

    this.phones?.forEach((a) => a.setIds());

    this.addresses?.forEach((a) => a.setIds());

    this.currentDamageWaivers?.forEach((a) => a.setIds());

    this.currentMemberships?.forEach((a) => a.setIds());

    this.currentCards?.forEach((a) => a.setIds());

    this.emergencyContacts?.forEach((a) => a.setIds());

    this.children?.forEach((a) => a.setIds());
  }
  assignFrom(
    config: PersonPublicParentDTOOptional,
    options?: AssignOptions,
  ): PersonPublicParentDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.assignId && this.assignIdApplyFilter(optionsRequired.filter)) {
      this.assignId = config.assignId;
      if (optionsRequired.unassign) this.assignIdIsSet = false;
      else this.assignIdIsSet = true;
    }
    if (config.prefix && this.prefixApplyFilter(optionsRequired.filter)) {
      this.prefix = config.prefix;
      if (optionsRequired.unassign) this.prefixIsSet = false;
      else this.prefixIsSet = true;
    }
    if (config.first && this.firstApplyFilter(optionsRequired.filter)) {
      this.first = config.first;
      if (optionsRequired.unassign) this.firstIsSet = false;
      else this.firstIsSet = true;
    }
    if (config.middle && this.middleApplyFilter(optionsRequired.filter)) {
      this.middle = config.middle;
      if (optionsRequired.unassign) this.middleIsSet = false;
      else this.middleIsSet = true;
    }
    if (config.last && this.lastApplyFilter(optionsRequired.filter)) {
      this.last = config.last;
      if (optionsRequired.unassign) this.lastIsSet = false;
      else this.lastIsSet = true;
    }
    if (config.suffix && this.suffixApplyFilter(optionsRequired.filter)) {
      this.suffix = config.suffix;
      if (optionsRequired.unassign) this.suffixIsSet = false;
      else this.suffixIsSet = true;
    }
    if (config.preferred && this.preferredApplyFilter(optionsRequired.filter)) {
      this.preferred = config.preferred;
      if (optionsRequired.unassign) this.preferredIsSet = false;
      else this.preferredIsSet = true;
    }
    if (
      config.organization &&
      this.organizationApplyFilter(optionsRequired.filter)
    ) {
      this.organization = config.organization;
      if (optionsRequired.unassign) this.organizationIsSet = false;
      else this.organizationIsSet = true;
    }
    if (config.email && this.emailApplyFilter(optionsRequired.filter)) {
      this.email = config.email;
      if (optionsRequired.unassign) this.emailIsSet = false;
      else this.emailIsSet = true;
    }
    if (
      config.allowSignouts &&
      this.allowSignoutsApplyFilter(optionsRequired.filter)
    ) {
      this.allowSignouts = config.allowSignouts;
      if (optionsRequired.unassign) this.allowSignoutsIsSet = false;
      else this.allowSignoutsIsSet = true;
    }
    if (
      config.personType &&
      this.personTypeApplyFilter(optionsRequired.filter)
    ) {
      this.personType = config.personType;
      if (optionsRequired.unassign) this.personTypeIsSet = false;
      else this.personTypeIsSet = true;
    }
    if (config.allergies && this.allergiesApplyFilter(optionsRequired.filter)) {
      this.allergies = config.allergies;
      if (optionsRequired.unassign) this.allergiesIsSet = false;
      else this.allergiesIsSet = true;
    }
    if (
      config.medications &&
      this.medicationsApplyFilter(optionsRequired.filter)
    ) {
      this.medications = config.medications;
      if (optionsRequired.unassign) this.medicationsIsSet = false;
      else this.medicationsIsSet = true;
    }
    if (
      config.specialNeeds &&
      this.specialNeedsApplyFilter(optionsRequired.filter)
    ) {
      this.specialNeeds = config.specialNeeds;
      if (optionsRequired.unassign) this.specialNeedsIsSet = false;
      else this.specialNeedsIsSet = true;
    }
    if (config.gender && this.genderApplyFilter(optionsRequired.filter)) {
      this.gender = config.gender;
      if (optionsRequired.unassign) this.genderIsSet = false;
      else this.genderIsSet = true;
    }
    if (
      config.occupation &&
      this.occupationApplyFilter(optionsRequired.filter)
    ) {
      this.occupation = config.occupation;
      if (optionsRequired.unassign) this.occupationIsSet = false;
      else this.occupationIsSet = true;
    }
    if (
      config.citizenship &&
      this.citizenshipApplyFilter(optionsRequired.filter)
    ) {
      this.citizenship = config.citizenship;
      if (optionsRequired.unassign) this.citizenshipIsSet = false;
      else this.citizenshipIsSet = true;
    }
    if (config.ethnicity && this.ethnicityApplyFilter(optionsRequired.filter)) {
      this.ethnicity = config.ethnicity;
      if (optionsRequired.unassign) this.ethnicityIsSet = false;
      else this.ethnicityIsSet = true;
    }
    if (config.language && this.languageApplyFilter(optionsRequired.filter)) {
      this.language = config.language;
      if (optionsRequired.unassign) this.languageIsSet = false;
      else this.languageIsSet = true;
    }
    if (
      config.matchingGifts &&
      this.matchingGiftsApplyFilter(optionsRequired.filter)
    ) {
      this.matchingGifts = config.matchingGifts;
      if (optionsRequired.unassign) this.matchingGiftsIsSet = false;
      else this.matchingGiftsIsSet = true;
    }
    if (config.student && this.studentApplyFilter(optionsRequired.filter)) {
      this.student = config.student;
      if (optionsRequired.unassign) this.studentIsSet = false;
      else this.studentIsSet = true;
    }
    if (config.school && this.schoolApplyFilter(optionsRequired.filter)) {
      this.school = config.school;
      if (optionsRequired.unassign) this.schoolIsSet = false;
      else this.schoolIsSet = true;
    }
    if (config.military && this.militaryApplyFilter(optionsRequired.filter)) {
      this.military = config.military;
      if (optionsRequired.unassign) this.militaryIsSet = false;
      else this.militaryIsSet = true;
    }
    if (
      config.reducedLunch &&
      this.reducedLunchApplyFilter(optionsRequired.filter)
    ) {
      this.reducedLunch = config.reducedLunch;
      if (optionsRequired.unassign) this.reducedLunchIsSet = false;
      else this.reducedLunchIsSet = true;
    }
    if (
      config.previousMember &&
      this.previousMemberApplyFilter(optionsRequired.filter)
    ) {
      this.previousMember = config.previousMember;
      if (optionsRequired.unassign) this.previousMemberIsSet = false;
      else this.previousMemberIsSet = true;
    }
    if (config.swimProof && this.swimProofApplyFilter(optionsRequired.filter)) {
      this.swimProof = config.swimProof;
      if (optionsRequired.unassign) this.swimProofIsSet = false;
      else this.swimProofIsSet = true;
    }
    if (config.dob && this.dobApplyFilter(optionsRequired.filter)) {
      this.dob = config.dob;
      if (optionsRequired.unassign) this.dobIsSet = false;
      else this.dobIsSet = true;
    }
    if (
      config.dobVerified &&
      this.dobVerifiedApplyFilter(optionsRequired.filter)
    ) {
      this.dobVerified = config.dobVerified;
      if (optionsRequired.unassign) this.dobVerifiedIsSet = false;
      else this.dobVerifiedIsSet = true;
    }
    if (
      config.stripeCustomerId &&
      this.stripeCustomerIdApplyFilter(optionsRequired.filter)
    ) {
      this.stripeCustomerId = config.stripeCustomerId;
      if (optionsRequired.unassign) this.stripeCustomerIdIsSet = false;
      else this.stripeCustomerIdIsSet = true;
    }
    if (config.temp && this.tempApplyFilter(optionsRequired.filter)) {
      this.temp = config.temp;
      if (optionsRequired.unassign) this.tempIsSet = false;
      else this.tempIsSet = true;
    }
    if (config.referrals && this.referralsApplyFilter(optionsRequired.filter)) {
      this.referrals = config.referrals?.map(
        (a) => new PersonReferralDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.referralsIsSet = false;
      else this.referralsIsSet = true;
    }
    if (config.phones && this.phonesApplyFilter(optionsRequired.filter)) {
      this.phones = config.phones?.map((a) => new PhoneDTOTracked(a, options));
      if (optionsRequired.unassign) this.phonesIsSet = false;
      else this.phonesIsSet = true;
    }
    if (config.addresses && this.addressesApplyFilter(optionsRequired.filter)) {
      this.addresses = config.addresses?.map(
        (a) => new AddressDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.addressesIsSet = false;
      else this.addressesIsSet = true;
    }
    if (config.isLocked && this.isLockedApplyFilter(optionsRequired.filter)) {
      this.isLocked = config.isLocked;
      if (optionsRequired.unassign) this.isLockedIsSet = false;
      else this.isLockedIsSet = true;
    }
    if (
      config.currentDamageWaivers &&
      this.currentDamageWaiversApplyFilter(optionsRequired.filter)
    ) {
      this.currentDamageWaivers = config.currentDamageWaivers?.map(
        (a) => new DamageWaiverDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentDamageWaiversIsSet = false;
      else this.currentDamageWaiversIsSet = true;
    }
    if (
      config.currentMemberships &&
      this.currentMembershipsApplyFilter(optionsRequired.filter)
    ) {
      this.currentMemberships = config.currentMemberships?.map(
        (a) => new MembershipDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentMembershipsIsSet = false;
      else this.currentMembershipsIsSet = true;
    }
    if (
      config.currentCards &&
      this.currentCardsApplyFilter(optionsRequired.filter)
    ) {
      this.currentCards = config.currentCards?.map(
        (a) => new CardDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.currentCardsIsSet = false;
      else this.currentCardsIsSet = true;
    }
    if (
      config.emergencyContacts &&
      this.emergencyContactsApplyFilter(optionsRequired.filter)
    ) {
      this.emergencyContacts = config.emergencyContacts?.map(
        (a) => new PersonPublicRelatedDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.emergencyContactsIsSet = false;
      else this.emergencyContactsIsSet = true;
    }
    if (config.children && this.childrenApplyFilter(optionsRequired.filter)) {
      this.children = config.children?.map(
        (a) => new PersonPublicChildDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childrenIsSet = false;
      else this.childrenIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonPublicParentDTOTrackedI {
    const cloned = {} as PersonPublicParentDTOTrackedI;
    if (
      this.assignIdIsSetDeep() &&
      this.assignIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.assignIdIsSet = true;
      cloned.assignId = this.assignId;
    } else {
      //cloned.assignIdIsSet = false
    }
    if (
      this.prefixIsSetDeep() &&
      this.prefixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.prefixIsSet = true;
      cloned.prefix = this.prefix;
    } else {
      //cloned.prefixIsSet = false
    }
    if (
      this.firstIsSetDeep() &&
      this.firstApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.firstIsSet = true;
      cloned.first = this.first;
    } else {
      //cloned.firstIsSet = false
    }
    if (
      this.middleIsSetDeep() &&
      this.middleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.middleIsSet = true;
      cloned.middle = this.middle;
    } else {
      //cloned.middleIsSet = false
    }
    if (
      this.lastIsSetDeep() &&
      this.lastApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.lastIsSet = true;
      cloned.last = this.last;
    } else {
      //cloned.lastIsSet = false
    }
    if (
      this.suffixIsSetDeep() &&
      this.suffixApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.suffixIsSet = true;
      cloned.suffix = this.suffix;
    } else {
      //cloned.suffixIsSet = false
    }
    if (
      this.preferredIsSetDeep() &&
      this.preferredApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.preferredIsSet = true;
      cloned.preferred = this.preferred;
    } else {
      //cloned.preferredIsSet = false
    }
    if (
      this.organizationIsSetDeep() &&
      this.organizationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.organizationIsSet = true;
      cloned.organization = this.organization;
    } else {
      //cloned.organizationIsSet = false
    }
    if (
      this.emailIsSetDeep() &&
      this.emailApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emailIsSet = true;
      cloned.email = this.email;
    } else {
      //cloned.emailIsSet = false
    }
    if (
      this.allowSignoutsIsSetDeep() &&
      this.allowSignoutsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allowSignoutsIsSet = true;
      cloned.allowSignouts = this.allowSignouts;
    } else {
      //cloned.allowSignoutsIsSet = false
    }
    if (
      this.personTypeIsSetDeep() &&
      this.personTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.personTypeIsSet = true;
      cloned.personType = this.personType;
    } else {
      //cloned.personTypeIsSet = false
    }
    if (
      this.allergiesIsSetDeep() &&
      this.allergiesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.allergiesIsSet = true;
      cloned.allergies = this.allergies;
    } else {
      //cloned.allergiesIsSet = false
    }
    if (
      this.medicationsIsSetDeep() &&
      this.medicationsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.medicationsIsSet = true;
      cloned.medications = this.medications;
    } else {
      //cloned.medicationsIsSet = false
    }
    if (
      this.specialNeedsIsSetDeep() &&
      this.specialNeedsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.specialNeedsIsSet = true;
      cloned.specialNeeds = this.specialNeeds;
    } else {
      //cloned.specialNeedsIsSet = false
    }
    if (
      this.genderIsSetDeep() &&
      this.genderApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.genderIsSet = true;
      cloned.gender = this.gender;
    } else {
      //cloned.genderIsSet = false
    }
    if (
      this.occupationIsSetDeep() &&
      this.occupationApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.occupationIsSet = true;
      cloned.occupation = this.occupation;
    } else {
      //cloned.occupationIsSet = false
    }
    if (
      this.citizenshipIsSetDeep() &&
      this.citizenshipApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.citizenshipIsSet = true;
      cloned.citizenship = this.citizenship;
    } else {
      //cloned.citizenshipIsSet = false
    }
    if (
      this.ethnicityIsSetDeep() &&
      this.ethnicityApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.ethnicityIsSet = true;
      cloned.ethnicity = this.ethnicity;
    } else {
      //cloned.ethnicityIsSet = false
    }
    if (
      this.languageIsSetDeep() &&
      this.languageApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.languageIsSet = true;
      cloned.language = this.language;
    } else {
      //cloned.languageIsSet = false
    }
    if (
      this.matchingGiftsIsSetDeep() &&
      this.matchingGiftsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.matchingGiftsIsSet = true;
      cloned.matchingGifts = this.matchingGifts;
    } else {
      //cloned.matchingGiftsIsSet = false
    }
    if (
      this.studentIsSetDeep() &&
      this.studentApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.studentIsSet = true;
      cloned.student = this.student;
    } else {
      //cloned.studentIsSet = false
    }
    if (
      this.schoolIsSetDeep() &&
      this.schoolApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.schoolIsSet = true;
      cloned.school = this.school;
    } else {
      //cloned.schoolIsSet = false
    }
    if (
      this.militaryIsSetDeep() &&
      this.militaryApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.militaryIsSet = true;
      cloned.military = this.military;
    } else {
      //cloned.militaryIsSet = false
    }
    if (
      this.reducedLunchIsSetDeep() &&
      this.reducedLunchApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reducedLunchIsSet = true;
      cloned.reducedLunch = this.reducedLunch;
    } else {
      //cloned.reducedLunchIsSet = false
    }
    if (
      this.previousMemberIsSetDeep() &&
      this.previousMemberApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.previousMemberIsSet = true;
      cloned.previousMember = this.previousMember;
    } else {
      //cloned.previousMemberIsSet = false
    }
    if (
      this.swimProofIsSetDeep() &&
      this.swimProofApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.swimProofIsSet = true;
      cloned.swimProof = this.swimProof;
    } else {
      //cloned.swimProofIsSet = false
    }
    if (
      this.dobIsSetDeep() &&
      this.dobApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dobIsSet = true;
      cloned.dob = this.dob;
    } else {
      //cloned.dobIsSet = false
    }
    if (
      this.dobVerifiedIsSetDeep() &&
      this.dobVerifiedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.dobVerifiedIsSet = true;
      cloned.dobVerified = this.dobVerified;
    } else {
      //cloned.dobVerifiedIsSet = false
    }
    if (
      this.stripeCustomerIdIsSetDeep() &&
      this.stripeCustomerIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.stripeCustomerIdIsSet = true;
      cloned.stripeCustomerId = this.stripeCustomerId;
    } else {
      //cloned.stripeCustomerIdIsSet = false
    }
    if (
      this.tempIsSetDeep() &&
      this.tempApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.tempIsSet = true;
      cloned.temp = this.temp;
    } else {
      //cloned.tempIsSet = false
    }
    if (
      this.referralsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.referralsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.referralsIsSet = true;
      cloned.referrals = this.referrals
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.referralsIsSet = false
    }
    if (
      this.phonesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.phonesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.phonesIsSet = true;
      cloned.phones = this.phones
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.phonesIsSet = false
    }
    if (
      this.addressesIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.addressesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.addressesIsSet = true;
      cloned.addresses = this.addresses
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.addressesIsSet = false
    }
    if (
      this.isLockedIsSetDeep() &&
      this.isLockedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isLockedIsSet = true;
      cloned.isLocked = this.isLocked;
    } else {
      //cloned.isLockedIsSet = false
    }
    if (
      this.currentDamageWaiversIsSetDeep(
        (a, b) => !a.isPrimary || !b.isArray,
      ) &&
      this.currentDamageWaiversApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentDamageWaiversIsSet = true;
      cloned.currentDamageWaivers = this.currentDamageWaivers
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentDamageWaiversIsSet = false
    }
    if (
      this.currentMembershipsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.currentMembershipsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentMembershipsIsSet = true;
      cloned.currentMemberships = this.currentMemberships
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentMembershipsIsSet = false
    }
    if (
      this.currentCardsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.currentCardsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.currentCardsIsSet = true;
      cloned.currentCards = this.currentCards
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.currentCardsIsSet = false
    }
    if (
      this.emergencyContactsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.emergencyContactsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.emergencyContactsIsSet = true;
      cloned.emergencyContacts = this.emergencyContacts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.emergencyContactsIsSet = false
    }
    if (
      this.childrenIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childrenApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childrenIsSet = true;
      cloned.children = this.children
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childrenIsSet = false
    }
    if (!isDeleted(this) && !this.assignIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonPublicParentDTOTrackedI {
    if (!this.assignIdApplyFilter(filter)) this.assignIdIsSet = false;

    if (!this.prefixApplyFilter(filter)) this.prefixIsSet = false;

    if (!this.firstApplyFilter(filter)) this.firstIsSet = false;

    if (!this.middleApplyFilter(filter)) this.middleIsSet = false;

    if (!this.lastApplyFilter(filter)) this.lastIsSet = false;

    if (!this.suffixApplyFilter(filter)) this.suffixIsSet = false;

    if (!this.preferredApplyFilter(filter)) this.preferredIsSet = false;

    if (!this.organizationApplyFilter(filter)) this.organizationIsSet = false;

    if (!this.emailApplyFilter(filter)) this.emailIsSet = false;

    if (!this.allowSignoutsApplyFilter(filter)) this.allowSignoutsIsSet = false;

    if (!this.personTypeApplyFilter(filter)) this.personTypeIsSet = false;

    if (!this.allergiesApplyFilter(filter)) this.allergiesIsSet = false;

    if (!this.medicationsApplyFilter(filter)) this.medicationsIsSet = false;

    if (!this.specialNeedsApplyFilter(filter)) this.specialNeedsIsSet = false;

    if (!this.genderApplyFilter(filter)) this.genderIsSet = false;

    if (!this.occupationApplyFilter(filter)) this.occupationIsSet = false;

    if (!this.citizenshipApplyFilter(filter)) this.citizenshipIsSet = false;

    if (!this.ethnicityApplyFilter(filter)) this.ethnicityIsSet = false;

    if (!this.languageApplyFilter(filter)) this.languageIsSet = false;

    if (!this.matchingGiftsApplyFilter(filter)) this.matchingGiftsIsSet = false;

    if (!this.studentApplyFilter(filter)) this.studentIsSet = false;

    if (!this.schoolApplyFilter(filter)) this.schoolIsSet = false;

    if (!this.militaryApplyFilter(filter)) this.militaryIsSet = false;

    if (!this.reducedLunchApplyFilter(filter)) this.reducedLunchIsSet = false;

    if (!this.previousMemberApplyFilter(filter))
      this.previousMemberIsSet = false;

    if (!this.swimProofApplyFilter(filter)) this.swimProofIsSet = false;

    if (!this.dobApplyFilter(filter)) this.dobIsSet = false;

    if (!this.dobVerifiedApplyFilter(filter)) this.dobVerifiedIsSet = false;

    if (!this.stripeCustomerIdApplyFilter(filter))
      this.stripeCustomerIdIsSet = false;

    if (!this.tempApplyFilter(filter)) this.tempIsSet = false;

    if (!this.referralsApplyFilter(filter)) this.referralsIsSet = false;

    this.referrals?.forEach((a) => a.unassignAll(filter));
    if (!this.phonesApplyFilter(filter)) this.phonesIsSet = false;

    this.phones?.forEach((a) => a.unassignAll(filter));
    if (!this.addressesApplyFilter(filter)) this.addressesIsSet = false;

    this.addresses?.forEach((a) => a.unassignAll(filter));
    if (!this.isLockedApplyFilter(filter)) this.isLockedIsSet = false;

    if (!this.currentDamageWaiversApplyFilter(filter))
      this.currentDamageWaiversIsSet = false;

    this.currentDamageWaivers?.forEach((a) => a.unassignAll(filter));
    if (!this.currentMembershipsApplyFilter(filter))
      this.currentMembershipsIsSet = false;

    this.currentMemberships?.forEach((a) => a.unassignAll(filter));
    if (!this.currentCardsApplyFilter(filter)) this.currentCardsIsSet = false;

    this.currentCards?.forEach((a) => a.unassignAll(filter));
    if (!this.emergencyContactsApplyFilter(filter))
      this.emergencyContactsIsSet = false;

    this.emergencyContacts?.forEach((a) => a.unassignAll(filter));
    if (!this.childrenApplyFilter(filter)) this.childrenIsSet = false;

    this.children?.forEach((a) => a.unassignAll(filter));
    return this;
  }
  assignIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.assignId,
      PersonPublicParentDTOMeta,
      this.assignId,
      this,
    );
  }
  assignIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.assignIdIsSet && this.assignIdApplyFilter(filter)) return true;

    return false;
  }
  prefixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.prefix,
      PersonPublicParentDTOMeta,
      this.prefix,
      this,
    );
  }
  prefixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.prefixIsSet && this.prefixApplyFilter(filter)) return true;

    return false;
  }
  firstApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.first,
      PersonPublicParentDTOMeta,
      this.first,
      this,
    );
  }
  firstIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.firstIsSet && this.firstApplyFilter(filter)) return true;

    return false;
  }
  middleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.middle,
      PersonPublicParentDTOMeta,
      this.middle,
      this,
    );
  }
  middleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.middleIsSet && this.middleApplyFilter(filter)) return true;

    return false;
  }
  lastApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.last,
      PersonPublicParentDTOMeta,
      this.last,
      this,
    );
  }
  lastIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.lastIsSet && this.lastApplyFilter(filter)) return true;

    return false;
  }
  suffixApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.suffix,
      PersonPublicParentDTOMeta,
      this.suffix,
      this,
    );
  }
  suffixIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.suffixIsSet && this.suffixApplyFilter(filter)) return true;

    return false;
  }
  preferredApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.preferred,
      PersonPublicParentDTOMeta,
      this.preferred,
      this,
    );
  }
  preferredIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.preferredIsSet && this.preferredApplyFilter(filter)) return true;

    return false;
  }
  organizationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.organization,
      PersonPublicParentDTOMeta,
      this.organization,
      this,
    );
  }
  organizationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.organizationIsSet && this.organizationApplyFilter(filter))
      return true;

    return false;
  }
  emailApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.email,
      PersonPublicParentDTOMeta,
      this.email,
      this,
    );
  }
  emailIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.emailIsSet && this.emailApplyFilter(filter)) return true;

    return false;
  }
  allowSignoutsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.allowSignouts,
      PersonPublicParentDTOMeta,
      this.allowSignouts,
      this,
    );
  }
  allowSignoutsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allowSignoutsIsSet && this.allowSignoutsApplyFilter(filter))
      return true;

    return false;
  }
  personTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.personType,
      PersonPublicParentDTOMeta,
      this.personType,
      this,
    );
  }
  personTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.personTypeIsSet && this.personTypeApplyFilter(filter)) return true;

    return false;
  }
  allergiesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.allergies,
      PersonPublicParentDTOMeta,
      this.allergies,
      this,
    );
  }
  allergiesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.allergiesIsSet && this.allergiesApplyFilter(filter)) return true;

    return false;
  }
  medicationsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.medications,
      PersonPublicParentDTOMeta,
      this.medications,
      this,
    );
  }
  medicationsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.medicationsIsSet && this.medicationsApplyFilter(filter))
      return true;

    return false;
  }
  specialNeedsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.specialNeeds,
      PersonPublicParentDTOMeta,
      this.specialNeeds,
      this,
    );
  }
  specialNeedsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.specialNeedsIsSet && this.specialNeedsApplyFilter(filter))
      return true;

    return false;
  }
  genderApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.gender,
      PersonPublicParentDTOMeta,
      this.gender,
      this,
    );
  }
  genderIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.genderIsSet && this.genderApplyFilter(filter)) return true;

    return false;
  }
  occupationApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.occupation,
      PersonPublicParentDTOMeta,
      this.occupation,
      this,
    );
  }
  occupationIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.occupationIsSet && this.occupationApplyFilter(filter)) return true;

    return false;
  }
  citizenshipApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.citizenship,
      PersonPublicParentDTOMeta,
      this.citizenship,
      this,
    );
  }
  citizenshipIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.citizenshipIsSet && this.citizenshipApplyFilter(filter))
      return true;

    return false;
  }
  ethnicityApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.ethnicity,
      PersonPublicParentDTOMeta,
      this.ethnicity,
      this,
    );
  }
  ethnicityIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.ethnicityIsSet && this.ethnicityApplyFilter(filter)) return true;

    return false;
  }
  languageApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.language,
      PersonPublicParentDTOMeta,
      this.language,
      this,
    );
  }
  languageIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.languageIsSet && this.languageApplyFilter(filter)) return true;

    return false;
  }
  matchingGiftsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.matchingGifts,
      PersonPublicParentDTOMeta,
      this.matchingGifts,
      this,
    );
  }
  matchingGiftsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.matchingGiftsIsSet && this.matchingGiftsApplyFilter(filter))
      return true;

    return false;
  }
  studentApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.student,
      PersonPublicParentDTOMeta,
      this.student,
      this,
    );
  }
  studentIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.studentIsSet && this.studentApplyFilter(filter)) return true;

    return false;
  }
  schoolApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.school,
      PersonPublicParentDTOMeta,
      this.school,
      this,
    );
  }
  schoolIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.schoolIsSet && this.schoolApplyFilter(filter)) return true;

    return false;
  }
  militaryApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.military,
      PersonPublicParentDTOMeta,
      this.military,
      this,
    );
  }
  militaryIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.militaryIsSet && this.militaryApplyFilter(filter)) return true;

    return false;
  }
  reducedLunchApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.reducedLunch,
      PersonPublicParentDTOMeta,
      this.reducedLunch,
      this,
    );
  }
  reducedLunchIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reducedLunchIsSet && this.reducedLunchApplyFilter(filter))
      return true;

    return false;
  }
  previousMemberApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.previousMember,
      PersonPublicParentDTOMeta,
      this.previousMember,
      this,
    );
  }
  previousMemberIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.previousMemberIsSet && this.previousMemberApplyFilter(filter))
      return true;

    return false;
  }
  swimProofApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.swimProof,
      PersonPublicParentDTOMeta,
      this.swimProof,
      this,
    );
  }
  swimProofIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.swimProofIsSet && this.swimProofApplyFilter(filter)) return true;

    return false;
  }
  dobApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.dob,
      PersonPublicParentDTOMeta,
      this.dob,
      this,
    );
  }
  dobIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dobIsSet && this.dobApplyFilter(filter)) return true;

    return false;
  }
  dobVerifiedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.dobVerified,
      PersonPublicParentDTOMeta,
      this.dobVerified,
      this,
    );
  }
  dobVerifiedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.dobVerifiedIsSet && this.dobVerifiedApplyFilter(filter))
      return true;

    return false;
  }
  stripeCustomerIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.stripeCustomerId,
      PersonPublicParentDTOMeta,
      this.stripeCustomerId,
      this,
    );
  }
  stripeCustomerIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.stripeCustomerIdIsSet && this.stripeCustomerIdApplyFilter(filter))
      return true;

    return false;
  }
  tempApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.temp,
      PersonPublicParentDTOMeta,
      this.temp,
      this,
    );
  }
  tempIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.tempIsSet && this.tempApplyFilter(filter)) return true;

    return false;
  }
  referralsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.referrals,
      PersonPublicParentDTOMeta,
      this.referrals,
      this,
    );
  }
  referralsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.referralsIsSet && this.referralsApplyFilter(filter)) return true;

    return this.referrals?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  phonesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.phones,
      PersonPublicParentDTOMeta,
      this.phones,
      this,
    );
  }
  phonesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.phonesIsSet && this.phonesApplyFilter(filter)) return true;

    return this.phones?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  addressesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.addresses,
      PersonPublicParentDTOMeta,
      this.addresses,
      this,
    );
  }
  addressesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.addressesIsSet && this.addressesApplyFilter(filter)) return true;

    return this.addresses?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  isLockedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.isLocked,
      PersonPublicParentDTOMeta,
      this.isLocked,
      this,
    );
  }
  isLockedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isLockedIsSet && this.isLockedApplyFilter(filter)) return true;

    return false;
  }
  currentDamageWaiversApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.currentDamageWaivers,
      PersonPublicParentDTOMeta,
      this.currentDamageWaivers,
      this,
    );
  }
  currentDamageWaiversIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentDamageWaiversIsSet &&
      this.currentDamageWaiversApplyFilter(filter)
    )
      return true;

    return (
      this.currentDamageWaivers?.find((a) => a.anySet(filter)) != undefined
    );
    return false;
  }
  currentMembershipsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.currentMemberships,
      PersonPublicParentDTOMeta,
      this.currentMemberships,
      this,
    );
  }
  currentMembershipsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.currentMembershipsIsSet &&
      this.currentMembershipsApplyFilter(filter)
    )
      return true;

    return this.currentMemberships?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  currentCardsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.currentCards,
      PersonPublicParentDTOMeta,
      this.currentCards,
      this,
    );
  }
  currentCardsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.currentCardsIsSet && this.currentCardsApplyFilter(filter))
      return true;

    return this.currentCards?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  emergencyContactsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.emergencyContacts,
      PersonPublicParentDTOMeta,
      this.emergencyContacts,
      this,
    );
  }
  emergencyContactsIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.emergencyContactsIsSet &&
      this.emergencyContactsApplyFilter(filter)
    )
      return true;

    return this.emergencyContacts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  childrenApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonPublicParentDTOMeta.children,
      PersonPublicParentDTOMeta,
      this.children,
      this,
    );
  }
  childrenIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childrenIsSet && this.childrenApplyFilter(filter)) return true;

    return this.children?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.assignIdIsSetDeep(filter)) return true;
    if (this.prefixIsSetDeep(filter)) return true;
    if (this.firstIsSetDeep(filter)) return true;
    if (this.middleIsSetDeep(filter)) return true;
    if (this.lastIsSetDeep(filter)) return true;
    if (this.suffixIsSetDeep(filter)) return true;
    if (this.preferredIsSetDeep(filter)) return true;
    if (this.organizationIsSetDeep(filter)) return true;
    if (this.emailIsSetDeep(filter)) return true;
    if (this.allowSignoutsIsSetDeep(filter)) return true;
    if (this.personTypeIsSetDeep(filter)) return true;
    if (this.allergiesIsSetDeep(filter)) return true;
    if (this.medicationsIsSetDeep(filter)) return true;
    if (this.specialNeedsIsSetDeep(filter)) return true;
    if (this.genderIsSetDeep(filter)) return true;
    if (this.occupationIsSetDeep(filter)) return true;
    if (this.citizenshipIsSetDeep(filter)) return true;
    if (this.ethnicityIsSetDeep(filter)) return true;
    if (this.languageIsSetDeep(filter)) return true;
    if (this.matchingGiftsIsSetDeep(filter)) return true;
    if (this.studentIsSetDeep(filter)) return true;
    if (this.schoolIsSetDeep(filter)) return true;
    if (this.militaryIsSetDeep(filter)) return true;
    if (this.reducedLunchIsSetDeep(filter)) return true;
    if (this.previousMemberIsSetDeep(filter)) return true;
    if (this.swimProofIsSetDeep(filter)) return true;
    if (this.dobIsSetDeep(filter)) return true;
    if (this.dobVerifiedIsSetDeep(filter)) return true;
    if (this.stripeCustomerIdIsSetDeep(filter)) return true;
    if (this.tempIsSetDeep(filter)) return true;
    if (this.referralsIsSetDeep(filter)) return true;
    if (this.phonesIsSetDeep(filter)) return true;
    if (this.addressesIsSetDeep(filter)) return true;
    if (this.isLockedIsSetDeep(filter)) return true;
    if (this.currentDamageWaiversIsSetDeep(filter)) return true;
    if (this.currentMembershipsIsSetDeep(filter)) return true;
    if (this.currentCardsIsSetDeep(filter)) return true;
    if (this.emergencyContactsIsSetDeep(filter)) return true;
    if (this.childrenIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
